import {MEMBER_MODULE, MEMBER_TAB} from "../model/user.model";

export const ALL_MEMBER_TABS: MEMBER_TAB[] = [MEMBER_TAB.ASSESSMENTS, MEMBER_TAB.COURSES, MEMBER_TAB.COMPETITIONS,
    MEMBER_TAB.HACKATHONS];

export const DEFAULT_ENABLED_MEMBER_TABS: MEMBER_TAB[] = [MEMBER_TAB.ASSESSMENTS];

export const MEMBER_TABS_BY_MEMBER_MODULE: Record<MEMBER_MODULE, MEMBER_TAB[]> = {
    [MEMBER_MODULE.CHALLENGES]: ALL_MEMBER_TABS
};

export const MEMBER_MODULE_LABEL: Record<MEMBER_MODULE, string> = {
    [MEMBER_MODULE.CHALLENGES]: 'Challenges'
};

export const MEMBER_TAB_LABEL: Record<MEMBER_TAB, string> = {
    [MEMBER_TAB.ASSESSMENTS]: 'Assessments',
    [MEMBER_TAB.COURSES]: 'Courses',
    [MEMBER_TAB.COMPETITIONS]: 'Competitions',
    [MEMBER_TAB.HACKATHONS]: 'Hackathons'
};
